module.exports = __webpack_public_path__ + "img/kehu_10@2x.a0b5ff47.png";